import { render, staticRenderFns } from "./proDetail.vue?vue&type=template&id=94c9ba94&scoped=true"
import script from "./proDetail.vue?vue&type=script&lang=js"
export * from "./proDetail.vue?vue&type=script&lang=js"
import style0 from "./proDetail.vue?vue&type=style&index=0&id=94c9ba94&prod&lang=less&scoped=true"
import style1 from "./proDetail.vue?vue&type=style&index=1&id=94c9ba94&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_efc848e9267e82724df6d0a8b137201b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c9ba94",
  null
  
)

export default component.exports